import { render } from "./GlobalSearchComponent.vue?vue&type=template&id=77544c61"
import script from "./GlobalSearchComponent.vue?vue&type=script&lang=js"
export * from "./GlobalSearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__